module.exports = __webpack_public_path__ + "static/stx-6c002e8aa910e717a7f3250e776e04e9.png";